export default "__VITE_ASSET__BTnVs6QW__"